import { loadPreferences, myPreferences, savePreferences } from '@/appLogic/view/preferences';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { TableType } from '@/coreDomainsModule/table';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { INCLUDE_NULL_MARKER } from '@/corePagesModule/constants/filterMarkers';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 列幅をDBに保存する
 */
export class BulkSaveTableFilterPreferenceUseCase {
  /**
   * 列幅の配列を保存する
   * @param tableType - テーブルの種類
   * @param filterItems - ヘッダーのキーと列幅のオブジェクト
   * @returns 失敗した時はエラーを返す
   */
  public async execute(tableType: TableType, filterItems: FilterContentItem[]): Promise<INetworkResult<void, Error>> {
    const filterInfos = filterItems.reduce<Record<string, string[]>>((acc, item) => {
      let selectedValue = [...item.selectedValue];
      if (item.filterType === 'LAST_CHECKED_AT') {
        const hasMarker = selectedValue.includes(INCLUDE_NULL_MARKER);
        if (item.includeNull && !hasMarker) {
          selectedValue.push(INCLUDE_NULL_MARKER);
        }
        if (!item.includeNull && hasMarker) {
          selectedValue = selectedValue.filter((value) => value !== INCLUDE_NULL_MARKER);
        }
      }
      acc[item.filterType] = selectedValue;
      return acc;
    }, {});
    try {
      // 最新のPreferencesを取得
      await loadPreferences();
      if (!myPreferences || !Object.keys(myPreferences).includes(tableType)) {
        return {
          status: {
            type: 'error',
            error: Error('保存に失敗しました'),
          },
        };
      }
      const preference = simpleCopy(myPreferences[tableType]);
      preference.filterInfos = filterInfos;
      myPreferences[tableType] = preference;
      await savePreferences();
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
